<template>
  <section class="page home">
      <div class="presentation">
          <signature />
          <div class="presentation__fade">
              <h2 class="presentation__title">Artista plástico</h2>
              <p class="presentation__para">Com uma grande variedade de cores e formas, o acervo é composto por obras que buscam retratar a sociedade humana, sua rotina, suas técnologias e sua história</p>
              <router-link :to="'/galeria'" class="presentation__button">Galeria</router-link>
          </div>
      </div>
      
      <decoration-bg v-if="screenType != 'phone' && screenType != 'tab-port' " routePath="home" />
      <social customClass="home" />
      
  </section>
  
</template>

<script>
import DecorationBg from "@/components/DecorationBg.vue";
import Signature from "@/components/Signature.vue";
import Social from "@/components/Social.vue";
import { respondMixin } from "../misc/mixins";

export default {
  name: "home",
  components: {
    DecorationBg,
    Signature,
    Social,
  },
  mixins: [respondMixin],
  computed: {
    signature: function() {
      return require("@/assets/sousa-branco.svg");
    },
  },
};
</script>
<style lang="scss">
.home {
  background: linear-gradient(80deg, $color-cream 55%, transparent 45%),
    linear-gradient(rgba($color-overlay, 0.4), rgba($color-overlay, 0.4)),
    url("~@/assets/img/home-bg.jpg") top no-repeat;
  background-position: right;
  background-size: auto 100%;
  height: 100vh;
  overflow-y: hidden;

  @include respond(tab-port) {
    background: linear-gradient(
        rgba($color-cream, 0.85),
        rgba($color-cream, 0.85)
      ),
      url("~@/assets/img/home-bg.png") no-repeat;
    background-size: cover;
    background-position: center;
  }
}
.presentation {
  position: absolute;
  top: 25%;
  left: 15%;
  z-index: 10;

  @include respond(tab-port) {
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
  }

  &__title {
    color: $color-wine-light;
    font-weight: 700;
    font-size: 2.5rem;
    margin-left: 7rem;
    margin-top: -4.2rem;

    @include respond(tab-port) {
      margin-top: -6rem;
    }
  }

  &__para {
    width: 30rem;
    font-size: 1.4rem;
    font-style: italic;
    margin-top: 3.4rem;
    line-height: 1.5;
    color: $color-wine-light;

    @include respond(tab-port) {
      margin-top: 7rem;
      font-size: 1.5rem;
    }
  }

  &__button {
    background-color: rgba($color-wine, 0.5);
    color: $color-cream;
    font-size: 1.2rem;
    padding: 0.7rem 1.6rem;
    display: inline-block;
    margin-top: 1rem;
    transition: all 1s;

    &:hover {
      background-color: rgba($color-wine, 0.8);
    }

    @include respond(tab-port) {
      margin-top: 3rem;
      font-size: 1.4rem;
    }
  }

  &__fade {
    animation: fade 5.6s;
  }
}
</style>
